import Cloud from '../modules/Cloud';

export default class Clouds {

  constructor(options) {
    this.container = options.elem;
    this.numClouds = options.num;
    this.clouds = [];

    for ( let i = 0; i < this.numClouds; i += 1 ) {
      this.clouds.push( new Cloud( { maxW:this.container.width(), maxH:this.container.height() } ) );
      this.container.append(this.clouds[i].cloud);

      this.clouds[i].reveal();
    }

    this.cloudCheck = setInterval( () => {
      this.checkClouds();
    }, 500);

  }

  checkClouds() {

    for ( let i = 0; i < this.numClouds; i += 1 ) {

      if ( this.clouds[i].stopped ) {
        this.clouds[i].restart();
        break;
      }

    }

  }

}




// WEBPACK FOOTER //
// ./js/controllers/modules/Clouds.js